import React from "react";
import Styles from "./GuideElements.module.css";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import guideDataEN from "../../../i18n/translations/GuideData/GuideDataEn";
import guideDataAr from "../../../i18n/translations/GuideData/GuideDataAr";
import guideDataKu from "../../../i18n/translations/GuideData/GuideDataKu";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

function GuideElements({ idGuide }) {
	const { t, i18n } = useTranslation();
	const { id } = useParams();

	const currentLanguage = i18n.language;

	const guideData =
		currentLanguage === "en"
			? guideDataEN
			: currentLanguage === "ar"
			? guideDataAr
			: guideDataKu;

	const guide = guideData.filter(
		(guide) => guide.idGuide.toString() === id.toString()
	)[0];

	const isRtl =
		i18n.language === "ar" || i18n.language === "ku";

	let firstName = "";

	if (guide.name) {
		firstName = guide.name.split(" ");
	} else {
		console.log("Name is undefined or null");
	}

	const stars = [1, 2, 3, 4, 5];
	// console.log(guide.GuideInfo);

	return (
		<div
			className={
				isRtl ? Styles.overlapGroupRtl : Styles.overlapGroup
			}
		>
			<img
				className={Styles.banner}
				alt='Banner'
				src={guide.imgCover}
			/>

			<div
				className={
					isRtl
						? Styles.infoContainerRtl
						: Styles.infoContainer
				}
			>
				<img
					src={guide.image}
					alt='profile'
					className={Styles.profilePic}
				/>

				<div
					className={
						isRtl ? Styles.userNameRtl : Styles.userName
					}
				>
					{guide.name}
				</div>
				<div
					className={
						isRtl ? Styles.provinceRtl : Styles.province
					}
				>
					{guide.province}
				</div>
			</div>

			<div className={Styles.infoWrapper}>
				<div className={Styles.exploreIraq}>
					{t("GuideProfile.explore")}
					<span className={Styles.exploreName}>
						{firstName[0]}
					</span>
				</div>
				<hr className={Styles.line} />
				<div className={Styles.rowWrapperPadding}>
					{guide.GuideInfo.map((data) => (
						<div
							key={data.title}
							className={Styles.rowWrapper}
						>
							<h3 className={Styles.rowTitle}>
								{data.title}
							</h3>
							<p className={Styles.rowParagraph}>
								{data.description}
							</p>
						</div>
					))}

					<div
						className={
							isRtl
								? Styles.contactBoxRtl
								: Styles.contactBox
						}
					>
						<p className={Styles.rate}>
							{/* {console.log("Reviews", guide.noOfReviews)}
							{console.log("Rate", guide.rate)} */}
							{stars.map((star) => (
								<span
									key={star}
									className={
										star <= guide.rate
											? `${Styles.star} ${Styles.filled}`
											: Styles.star
									}
								>
									<StarRoundedIcon fontSize='large' />
								</span>
							))}
						</p>
						<p className={Styles.noOfReviews}>
							{t("GuideProfile.reviews")} :
							{guide.noOfReviews}
						</p>
						<hr className={Styles.line} />
						<p className={Styles.paragraph}>
							{t("GuideProfile.message")}
							<span className={Styles.paragraphName}>
								{firstName[0]}
							</span>
						</p>
						<button
							className={isRtl ? Styles.btnRtl : Styles.btn}
						>
							<a
								href='whatsapp://send?phone=7818403457'
								target='_blank'
								rel='noreferrer' //for security
							>
								{t("GuideProfile.contact")}
								<WhatsAppIcon />
							</a>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default GuideElements;
